import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  isAuthenticated: false,
  loading: false,
  error: null,
  permissions: {}, // ✅ Store user permissions
  permissionsLoading: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = true;
      state.loading = false;
      state.error = null;
    },
    clearUser: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = null;
      state.permissions = {}; // ✅ Clear permissions on logout
      state.permissionsLoading = false;
    },
    setAuthLoading: (state, action) => {
      state.loading = action.payload;
    },
    setAuthError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    // ✅ Permissions actions
    setPermissions: (state, action) => {
      state.permissions = action.payload;
      state.permissionsLoading = false;
    },
    setPermissionsLoading: (state, action) => {
      state.permissionsLoading = action.payload;
    },
    clearPermissions: (state) => {
      state.permissions = {};
      state.permissionsLoading = false;
    },
  },
});

export const { 
  setUser, 
  clearUser, 
  setAuthLoading, 
  setAuthError,
  setPermissions,
  setPermissionsLoading,
  clearPermissions,
} = authSlice.actions;

export const selectUser = (state) => state.auth.user;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectAuthLoading = (state) => state.auth.loading;
export const selectAuthError = (state) => state.auth.error;
export const selectPermissions = (state) => state.auth.permissions;
export const selectPermissionsLoading = (state) => state.auth.permissionsLoading;

export default authSlice.reducer;